import Link from "next/link";
import { useRouter } from "next/router";
import { useOfferModeWithFsecure } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Panel, Separator } from "@nju/ui";

export function ReactivationSuccessPage() {
  const router = useRouter();
  const mode = useOfferModeWithFsecure();
  const params =
    portalRoutes.mojeKonto.mojeUslugi.reaktywacja.uslugaReaktywowana
      .input(router.query)
      .unwrap();

  return (
    <Panel testId="reactivation-success-panel">
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        gotowe!
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Icon height={90} name="document-incircle-succes" width={90} />
      </div>
      <Separator size="s" tone="invisible" />
      <BlockText
        align="center"
        size={{ "@onlyMobile": "s", "@fromTablet": "m" }}
      >
        Twoja usługa zostanie włączona zaraz po potwierdzeniu płatności -
        będziemy
        <br />
        informować Cię o zmianach statusu.
      </BlockText>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({
            mode,
            ...(params?.userId && { userId: params.userId }),
          })}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }}>ok</A>
        </Link>
      </div>
    </Panel>
  );
}
